import { defineCustomElement } from '@tyler-components-web/core';
import { ChipSetComponent } from './chip-set';
export * from './chip-set-adapter';
export * from './chip-set-constants';
export * from './chip-set-foundation';
export * from './chip-set';
export function defineChipSetComponent() {
    defineCustomElement(ChipSetComponent);
}
